import { createRoutes } from 'shared/hocs'

import Profile from './profile'
import Inwins from './inwins'
import MakeInwin from './makeInWin'
import Beneficiaries from './beneficiaries'
import Account from './account'
import Address from './address'
import PersonalInfo from './personalInfo'
import ChangePassword from './changePassword'
import DonationReceipts from './donationReceipts'
// import Support from './support'
import Layout from './shared/layout'
import Athletes from './athletes'
import Teams from './teams'
import Tournaments from './tournaments'

const ProfileRoutes = createRoutes(
  ({ match }) => {
    return [
      {
        path: `${match.path}/beneficiaries`,
        component: Beneficiaries,
      },
      {
        path: `${match.path}/inwins`,
        component: Inwins,
      },
      {
        path: `${match.path}/makeInWins`,
        component: MakeInwin,
      },
      {
        path: `${match.path}/athletes`,
        component: Athletes,
      },
      {
        path: `${match.path}/account`,
        component: Profile,
      },
      {
        path: `${match.path}/balance`,
        component: Account,
      },
      {
        path: `${match.path}/teams`,
        component: Teams,
      },
      {
        path: `${match.path}/tournaments`,
        component: Tournaments,
      },
      {
        path: `${match.path}/address`,
        component: Address,
      },
      {
        path: `${match.path}/personal-info`,
        component: PersonalInfo,
      },
      {
        path: `${match.path}/change-password`,
        component: ChangePassword,
      },
      {
        path: `${match.path}/donation-receipts`,
        component: DonationReceipts,
      },
      {
        exact: true,
        path: match.path,
        component: Profile,
      },
    ]
  },
  { layout: Layout }
)

export default ProfileRoutes
